<template>
  <dc-layout-main :is-breadcrumb="true">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item>运营管理</a-breadcrumb-item>
      <a-breadcrumb-item>区号信息</a-breadcrumb-item>
    </a-breadcrumb>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosAreaCodeInformation"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="name" label="客户名称">
              <a-input v-model:value="queryForm.name" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="name" label="客户代码">
              <a-input v-model:value="queryForm.name" allowClear placeholder="请输入" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="deleteRow(record)">删除</a-button>
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit()">新增</a-button>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, onMounted, ref } from 'vue'
import { listByParamCodes } from '@/api/common'
import { potentialList } from '@/api/overseasSales/customerCenter'

import { CustomerCode } from '@/typings/api/customerCenter'
export default { name: 'list' }
</script>
<script setup lang="ts">
// eslint-disable-next-line func-call-spacing
const editModalRef = ref<{ toggle: (row?: CustomerCode) => void }>()

const tableRef = ref()
const queryForm = reactive({
  name: ''
})

onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: ['zbu_grade', 'zbu_partner_nature', 'zbu_main_customers', 'zbu_campaign_type', 'zbu_partner_role']
  }).then((res) => {
    if (res.code === 200) {
      console.log(11)
    }
  })
}
// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  potentialList(params).then((res) => {
    callBack(res)
  })
}
const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const columns = ref([
  { title: '客户名称', dataIndex: 'noset' },
  { title: '关联客户代码', dataIndex: 'noset' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: CustomerCode) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: CustomerCode) => {
  Modal.delete({
    name: row.arkCode,
    onOk() {
      tableRef.value?.delFetch()
      console.log(1)
    }
  })
}
</script>

<style scoped></style>
